const translations = {
    "New task": "Neuen Beratungslauf erstellen",
    "Edit": "Bearbeiten",
    "Delete": "Löschen",
    "Move": "Verschieben",
    "Up": "Nach oben",
    "Down": "Nach unten",
    "Copy": "Kopieren",
    "Cut": "Ausschneiden",
    "Paste": "Einfügen",
    "Indent": "Einrücken",
    "Outdent": "Ausrücken",
    "Convert to": "Umwandeln in",
    "Task": "Aufgabe",
    "Summary task": "Sammelaufgabe",
    "Milestone": "Meilenstein",
    "Urgent": "Dringend",
    "Narrow": "Schmal",
    "Progress": "Fortschritt",
    "Rounded": "Abgerundet",
    "Add": "Hinzufügen",
    "Child task": "Unteraufgabe",
    "Task above": "Aufgabe darüber",
    "Task below": "Aufgabe darunter"
};

export const translateMenuItems = (items) => {
    return items.map(item => {
        const translated = { ...item };

        if (translated.text && translations[translated.text]) {
            translated.text = translations[translated.text];
        }

        if (Array.isArray(translated.data)) {
            translated.data = translateMenuItems(translated.data);
        }

        return translated;
    });
};
